import { t } from "i18next";
import React from "react";
import { useTypeSelector } from "../../../../../../../hooks/useTypeSelector";

import "./PersonalDetailsPage.scss";

const PersonalDetailsPage = () => {
  const { user } = useTypeSelector((data) => data.accountInfoReducer);
  return (
    <div
      className="u-i-e-p-p-content-bc u-i-common-content user-profile"
      data-scroll-lock-scrollable=""
    >
      <div>
        <div className="u-i-p-control-item-holder-bc">
          <div className="eligible-bonus">
            <i className="bc-i-player-info" />
            <span className="eligible-bonus-title">
              {t("admin.Eligibleforbonus")}:{" "}
            </span>
            <b className="eligible-bonus-status green">{t("admin.Yes")}</b>
          </div>
        </div>
        <div className="userProfile-content" data-scroll-lock-scrollable="">
          <div className="userProfileWrapper-bc userProfileSection-0">
            <div className="u-i-p-control-item-holder-bc">
              <div className="form-control-bc default valid filled">
                <label className="form-control-label-bc inputs">
                  <input
                    type="text"
                    className="form-control-input-bc"
                    name="id"
                    readOnly={true}
                    step={0}
                    defaultValue={user.id}
                  />
                  <i className="form-control-input-stroke-bc" />
                  <span className="form-control-title-bc ellipsis">ID</span>
                </label>
              </div>
            </div>
            <div className="u-i-p-control-item-holder-bc">
              <div className="form-control-bc default valid filled">
                <label className="form-control-label-bc inputs">
                  <input
                    type="text"
                    className="form-control-input-bc"
                    name="username"
                    readOnly={true}
                    step={0}
                    defaultValue={user.username}
                  />
                  <i className="form-control-input-stroke-bc" />
                  <span className="form-control-title-bc ellipsis">
                    {t("admin.Username")}
                  </span>
                </label>
              </div>
            </div>
            <div className="u-i-p-control-item-holder-bc">
              <div className="form-control-bc default valid filled">
                <label className="form-control-label-bc inputs">
                  <input
                    type="text"
                    className="form-control-input-bc"
                    name="first_name"
                    readOnly={true}
                    step={0}
                    defaultValue={user.firstname}
                  />
                  <i className="form-control-input-stroke-bc" />
                  <span className="form-control-title-bc ellipsis">
                    {t("admin.Firstname")}
                  </span>
                </label>
              </div>
            </div>
            <div className="u-i-p-control-item-holder-bc">
              <div className="form-control-bc default valid filled">
                <label className="form-control-label-bc inputs">
                  <input
                    type="text"
                    className="form-control-input-bc"
                    name="last_name"
                    readOnly={true}
                    step={0}
                    defaultValue={user.lastname}
                  />
                  <i className="form-control-input-stroke-bc" />
                  <span className="form-control-title-bc ellipsis">
                    {t("admin.Lastname")}
                  </span>
                </label>
              </div>
            </div>
            <div className="u-i-p-control-item-holder-bc">
              <div className="form-control-bc default valid filled">
                <label className="form-control-label-bc inputs">
                  <input
                    type="email"
                    className="form-control-input-bc"
                    autoComplete="username"
                    name="email"
                    readOnly={true}
                    step={0}
                    defaultValue={user.email}
                  />
                  <i className="form-control-input-stroke-bc" />
                  <span className="form-control-title-bc ellipsis">
                    {t("admin.Email")}
                  </span>
                </label>
              </div>
            </div>
            <div className="u-i-p-control-item-holder-bc">
              <div className="form-control-bc default valid filled">
                <label className="form-control-label-bc inputs">
                  <input
                    type="text"
                    className="form-control-input-bc"
                    name="doc_number"
                    readOnly={true}
                    step={0}
                    defaultValue={
                      user?.profile?.passport ? user?.profile?.passport : ""
                    }
                  />
                  <i className="form-control-input-stroke-bc" />
                  <span className="form-control-title-bc ellipsis">
                    {t("admin.PassportID")}
                  </span>
                </label>
              </div>
            </div>
            <div className="u-i-p-control-item-holder-bc">
              <div className="form-control-bc default valid filled">
                <label className="form-control-label-bc inputs">
                  <input
                    type="text"
                    className="form-control-input-bc"
                    name="birth_date"
                    readOnly={true}
                    step={0}
                    defaultValue={
                      user?.profile?.birthday ? user?.profile?.birthday : ""
                    }
                  />
                  <i className="form-control-input-stroke-bc" />
                  <span className="form-control-title-bc ellipsis">
                    {t("admin.Birthdate")}
                  </span>
                </label>
              </div>
              <i className="dropdownIcon-bc bc-i-datepicker disabled" />
            </div>
            <div className="u-i-p-control-item-holder-bc">
              <div className="form-control-bc select has-icon focused valid filled">
                <label className="form-control-label-bc inputs">
                  <input
                    type="text"
                    className="form-control-input-bc"
                    name="gender"
                    readOnly={true}
                    step={0}
                    defaultValue="Male"
                  />
                  <i className="form-control-input-stroke-bc" />
                  <span className="form-control-title-bc ellipsis">
                    {t("admin.Gender")}
                  </span>
                </label>
              </div>
            </div>
            <div className="u-i-p-control-item-holder-bc dropdownArrowParent-bc">
              <div className="form-control-bc select select-flag filled">
                <label className="form-control-label-bc inputs">
                  <i className="select-icon-bc ftr-lang-bar-flag-bc flag-bc kazakhstan" />
                  <select className="form-control-select-bc ellipsis">
                    <option value="AF">Afghanistan</option>
                    <option value="AX">Aland Islands</option>
                    <option value="AL">Albania</option>
                    <option value="DZ">Algeria</option>
                    <option value="AS">American Samoa</option>
                    <option value="AD">Andorra</option>
                    <option value="AO">Angola</option>
                    <option value="AI">Anguilla</option>
                    <option value="AQ">Antarctica</option>
                    <option value="AG">Antigua and Barbuda</option>
                    <option value="AR">Argentina</option>
                    <option value="AM">Armenia</option>
                    <option value="AW">Aruba</option>
                    <option value="AU">Australia</option>
                    <option value="AT">Austria</option>
                    <option value="AZ">Azerbaijan</option>
                    <option value="BS">Bahamas</option>
                    <option value="BH">Bahrain</option>
                    <option value="BD">Bangladesh</option>
                    <option value="BB">Barbados</option>
                    <option value="BY">Belarus</option>
                    <option value="BE">Belgium</option>
                    <option value="BZ">Belize</option>
                    <option value="BJ">Benin</option>
                    <option value="BM">Bermuda</option>
                    <option value="BT">Bhutan</option>
                    <option value="BO">Bolivia</option>
                    <option value="BQ">Bonaire</option>
                    <option value="BA">Bosnia and Herzegovina</option>
                    <option value="BW">Botswana</option>
                    <option value="BV">Bouvet Island</option>
                    <option value="BR">Brazil</option>
                    <option value="IO">British Indian Ocean Territory</option>
                    <option value="BN">Brunei Darussalam</option>
                    <option value="BG">Bulgaria</option>
                    <option value="BF">Burkina Faso</option>
                    <option value="BI">Burundi</option>
                    <option value="CV">Cabo Verde</option>
                    <option value="KH">Cambodia</option>
                    <option value="CM">Cameroon</option>
                    <option value="CA">Canada</option>
                    <option value="KY">Cayman Islands</option>
                    <option value="CF">Central African Republic</option>
                    <option value="TD">Chad</option>
                    <option value="CL">Chile</option>
                    <option value="CN">China</option>
                    <option value="CX">Christmas Island</option>
                    <option value="CC">Cocos (Keeling) Islands</option>
                    <option value="CO">Colombia</option>
                    <option value="KM">Comoros</option>
                    <option value="CG">Congo</option>
                    <option value="CD">
                      Congo, Democratic Republic of the (Zaire)
                    </option>
                    <option value="CK">Cook Islands</option>
                    <option value="CR">Costa Rica</option>
                    <option value="CI">Cote dIvoire</option>
                    <option value="HR">Croatia</option>
                    <option value="CU">Cuba</option>
                    <option value="CW">Curacao</option>
                    <option value="CY">Cyprus</option>
                    <option value="CZ">Czech Republic</option>
                    <option value="DK">Denmark</option>
                    <option value="DJ">Djibouti</option>
                    <option value="DM">Dominica</option>
                    <option value="DO">Dominican Republic</option>
                    <option value="EC">Ecuador</option>
                    <option value="EG">Egypt</option>
                    <option value="SV">El Salvador</option>
                    <option value="GQ">Equatorial Guinea</option>
                    <option value="ER">Eritrea</option>
                    <option value="EE">Estonia</option>
                    <option value="ET">Ethiopia</option>
                    <option value="FK">Falkland Islands</option>
                    <option value="FO">Faroe Islands</option>
                    <option value="FJ">Fiji</option>
                    <option value="FI">Finland</option>
                    <option value="FR">France</option>
                    <option value="GF">French Guiana</option>
                    <option value="PF">French Polynesia</option>
                    <option value="TF">French Southern Territories</option>
                    <option value="GA">Gabon</option>
                    <option value="GM">Gambia</option>
                    <option value="GE">Georgia</option>
                    <option value="DE">Germany</option>
                    <option value="GE-AB">Abkhazia</option>
                    <option value="GH">Ghana</option>
                    <option value="GI">Gibraltar</option>
                    <option value="GR">Greece</option>
                    <option value="GL">Greenland</option>
                    <option value="GD">Grenada</option>
                    <option value="GP">Guadeloupe</option>
                    <option value="GU">Guam</option>
                    <option value="GT">Guatemala</option>
                    <option value="GG">Guernsey</option>
                    <option value="GN">Guinea</option>
                    <option value="GW">Guinea-Bissau</option>
                    <option value="GY">Guyana</option>
                    <option value="HT">Haiti</option>
                    <option value="HM">
                      Heard Island and McDonald Islands
                    </option>
                    <option value="VA">Holy See</option>
                    <option value="HN">Honduras</option>
                    <option value="HK">Hong Kong</option>
                    <option value="HU">Hungary</option>
                    <option value="IS">Iceland</option>
                    <option value="IN">India</option>
                    <option value="ID">Indonesia</option>
                    <option value="IR">Iran</option>
                    <option value="IQ">Iraq</option>
                    <option value="IE">Ireland</option>
                    <option value="IM">Isle of Man</option>
                    <option value="IL">Israel</option>
                    <option value="IT">Italy</option>
                    <option value="JM">Jamaica</option>
                    <option value="JP">Japan</option>
                    <option value="JE">Jersey</option>
                    <option value="JO">Jordan</option>
                    <option value="KZ">Kazakhstan</option>
                    <option value="KE">Kenya</option>
                    <option value="KI">Kiribati</option>
                    <option value="KP">Korea, North</option>
                    <option value="KW">Kuwait</option>
                    <option value="KG">Kyrgyzstan</option>
                    <option value="LA">Laos</option>
                    <option value="LV">Latvia</option>
                    <option value="LB">Lebanon</option>
                    <option value="LS">Lesotho</option>
                    <option value="LR">Liberia</option>
                    <option value="LY">Libya</option>
                    <option value="LI">Liechtenstein</option>
                    <option value="LT">Lithuania</option>
                    <option value="LU">Luxembourg</option>
                    <option value="MO">Macao</option>
                    <option value="MG">Madagascar</option>
                    <option value="MW">Malawi</option>
                    <option value="MY">Malaysia</option>
                    <option value="MV">Maldives</option>
                    <option value="ML">Mali</option>
                    <option value="MT">Malta</option>
                    <option value="MH">Marshall Islands</option>
                    <option value="MQ">Martinique</option>
                    <option value="MR">Mauritania</option>
                    <option value="MU">Mauritius</option>
                    <option value="YT">Mayotte</option>
                    <option value="MX">Mexico</option>
                    <option value="FM">Micronesia, Federated States of</option>
                    <option value="MD">Moldova</option>
                    <option value="MC">Monaco</option>
                    <option value="MN">Mongolia</option>
                    <option value="ME">Montenegro</option>
                    <option value="MS">Montserrat</option>
                    <option value="MA">Morocco</option>
                    <option value="MZ">Mozambique</option>
                    <option value="MM">Myanmar</option>
                    <option value="NA">Namibia</option>
                    <option value="NR">Nauru</option>
                    <option value="NP">Nepal</option>
                    <option value="NL">Netherlands</option>
                    <option value="NC">New Caledonia</option>
                    <option value="NZ">New Zealand</option>
                    <option value="NI">Nicaragua</option>
                    <option value="NE">Niger</option>
                    <option value="NG">Nigeria</option>
                    <option value="NU">Niue</option>
                    <option value="NF">Norfolk Island</option>
                    <option value="MP">Northern Mariana Islands</option>
                    <option value="MK">North Macedonia</option>
                    <option value="NO">Norway</option>
                    <option value="OM">Oman</option>
                    <option value="PK">Pakistan</option>
                    <option value="PW">Palau</option>
                    <option value="PS">Palestine, State of</option>
                    <option value="PA">Panama</option>
                    <option value="PG">Papua New Guinea</option>
                    <option value="PY">Paraguay</option>
                    <option value="PE">Peru</option>
                    <option value="PH">Philippines</option>
                    <option value="PN">Pitcairn</option>
                    <option value="PL">Poland</option>
                    <option value="PT">Portugal</option>
                    <option value="PR">Puerto Rico</option>
                    <option value="QA">Qatar</option>
                    <option value="RE">Reunion</option>
                    <option value="RO">Romania</option>
                    <option value="RU">Russia</option>
                    <option value="RW">Rwanda</option>
                    <option value="BL">Saint Barthelemy</option>
                    <option value="SH">Saint Helena</option>
                    <option value="KN">Saint Kitts and Nevis</option>
                    <option value="LC">Saint Lucia</option>
                    <option value="MF">Saint Martin (France)</option>
                    <option value="PM">Saint Pierre and Miquelon</option>
                    <option value="VC">Saint Vincent and the Grenadines</option>
                    <option value="WS">Samoa</option>
                    <option value="SM">San Marino</option>
                    <option value="ST">Sao Tome and Principe</option>
                    <option value="SA">Saudi Arabia</option>
                    <option value="SN">Senegal</option>
                    <option value="RS">Serbia</option>
                    <option value="SC">Seychelles</option>
                    <option value="SL">Sierra Leone</option>
                    <option value="SG">Singapore</option>
                    <option value="SX">Sint Maarten (Netherlands)</option>
                    <option value="SK">Slovakia</option>
                    <option value="SI">Slovenia</option>
                    <option value="SB">Solomon Islands</option>
                    <option value="SO">Somalia</option>
                    <option value="ZA">South Africa</option>
                    <option value="GS">
                      South Georgia and the South Sandwich Islands
                    </option>
                    <option value="SS">South Sudan</option>
                    <option value="KR">South Korea</option>
                    <option value="ES">Spain</option>
                    <option value="LK">Sri Lanka</option>
                    <option value="SD">Sudan</option>
                    <option value="SR">Suriname</option>
                    <option value="SJ">Svalbard and Jan Mayen</option>
                    <option value="SZ">Swaziland</option>
                    <option value="SE">Sweden</option>
                    <option value="CH">Switzerland</option>
                    <option value="SY">Syria</option>
                    <option value="TW">Taiwan</option>
                    <option value="TJ">Tajikistan</option>
                    <option value="TZ">Tanzania</option>
                    <option value="TH">Thailand</option>
                    <option value="TL">Timor-Leste</option>
                    <option value="TG">Togo</option>
                    <option value="TK">Tokelau</option>
                    <option value="TO">Tonga</option>
                    <option value="TT">Trinidad and Tobago</option>
                    <option value="TN">Tunisia</option>
                    <option value="TR">Turkey</option>
                    <option value="TM">Turkmenistan</option>
                    <option value="TC">Turks and Caicos Islands</option>
                    <option value="XC">
                      Turkish Republic of Northern Cyprus
                    </option>
                    <option value="TV">Tuvalu</option>
                    <option value="UG">Uganda</option>
                    <option value="UA">Ukraine</option>
                    <option value="AE">United Arab Emirates</option>
                    <option value="GB">United Kingdom</option>
                    <option value="US">United States</option>
                    <option value="UY">Uruguay</option>
                    <option value="UZ">Uzbekistan</option>
                    <option value="VU">Vanuatu</option>
                    <option value="VE">Venezuela</option>
                    <option value="VN">Vietnam</option>
                    <option value="VG">Virgin Islands, British</option>
                    <option value="VI">Virgin Islands, U.S.</option>
                    <option value="WF">Wallis and Futuna</option>
                    <option value="EH">Western Sahara</option>
                    <option value="YE">Yemen</option>
                    <option value="ZM">Zambia</option>
                    <option value="ZW">Zimbabwe</option>
                  </select>
                  <i className="form-control-icon-bc bc-i-small-arrow-down" />
                  <span className="form-control-title-bc ellipsis">
                    {t("admin.Country")}
                  </span>
                </label>
              </div>
            </div>
            <div className="u-i-p-control-item-holder-bc">
              <div className="form-control-bc default valid filled">
                <label className="form-control-label-bc inputs">
                  <input
                    type="text"
                    className="form-control-input-bc"
                    name="city"
                    step={0}
                    defaultValue={
                      user?.profile?.city ? user?.profile?.city : ""
                    }
                  />
                  <i className="form-control-input-stroke-bc" />
                  <span className="form-control-title-bc ellipsis">
                    {t("admin.City")}
                  </span>
                </label>
              </div>
            </div>
            <div className="u-i-p-control-item-holder-bc">
              <div className="form-control-bc default valid filled">
                <label className="form-control-label-bc inputs">
                  <input
                    type="text"
                    className="form-control-input-bc"
                    name="address"
                    step={0}
                    defaultValue={
                      user?.profile?.address ? user?.profile?.address : ""
                    }
                  />
                  <i className="form-control-input-stroke-bc" />
                  <span className="form-control-title-bc ellipsis">
                    {t("admin.Address")}
                  </span>
                </label>
              </div>
            </div>
            <div className="u-i-p-control-item-holder-bc">
              <div className="form-controls-group-bc telephone">
                <div className="form-controls-field-content">
                  <div className="form-controls-field-bc">
                    <div className="form-control-bc default  filled valid">
                      <label className="form-control-label-bc inputs">
                        <input
                          type="tel"
                          name="phoneNumber"
                          className="form-control-input-bc"
                          readOnly={true}
                          step={0}
                          defaultValue={
                            user?.profile?.phone ? user?.profile?.phone : ""
                          }
                        />
                        <i className="form-control-input-stroke-bc" />
                        <span className="form-control-title-bc ellipsis">
                          {t("admin.Phonenumber")}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="userProfileWrapper-bc userProfileSection-1">
            <div className="u-i-p-control-item-holder-bc">
              <hr className="passwordAboveSeparator" />
            </div>
            <div className="u-i-p-control-item-holder-bc">
              <div className="entrance-f-item-bc  ">
                <div className="entrance-f-error-message-bc">
                  {t("admin.Enteryourpasswordtosavechanges")}
                </div>
              </div>
            </div>
            <div className="u-i-p-control-item-holder-bc">
              <div className="form-control-bc default has-icon ">
                <label className="form-control-label-bc inputs">
                  <input
                    type="password"
                    className="form-control-input-bc"
                    autoComplete="current-password"
                    name="password"
                    step={0}
                  />
                  <i className="form-control-input-stroke-bc" />
                  <span className="form-control-title-bc ellipsis">
                    {t("admin.Currentpassword")}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="u-i-p-c-footer-bc">
          <button
            className="btn a-color right-aligned "
            type="submit"
            title="Save changes"
            disabled={true}
          >
            <span>{t("admin.Savechanges")}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export { PersonalDetailsPage };
